// @flow
import * as React from 'react';

import styles from './ScrollToTopButton.module.css';

export const scrollToTopGradually = () => {
  let scrollTop;
  if (document.documentElement !== null && document.documentElement.scrollTop) {
    scrollTop = document.documentElement.scrollTop;
  } else if (document.body !== null) {
    scrollTop = document.body.scrollTop;
  } else {
    scrollTop = 0;
  }
  if (scrollTop > 0) {
    window.requestAnimationFrame(scrollToTopGradually);
    window.scrollTo(0, scrollTop - scrollTop / 8);
  }
};

const ScrollToTopButton = () => (
  <button
    className={`naked-button ${styles.button}`}
    onClick={scrollToTopGradually}
    type="button"
  >
    scroll to top
  </button>
);

export default ScrollToTopButton;
